// React Scripts injects this value when the app starts or builds.
const configuredClientId = (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();
export const GOOGLE_CLIENT_ID = /^\d+-[a-z0-9_-]+\.apps\.googleusercontent\.com$/i.test(configuredClientId)
  ? configuredClientId
  : '';
